import { type StorageThreadType } from '@mastra/core/memory';
import { useQuery } from '@tanstack/react-query';

import { captureException } from '../../logger/Logger';
import { useMastraClient } from '../providers/MastraClient';

export const useGetMastraThread = ({
    threadId,
    agentId,
    refetchInterval,
}: {
    threadId?: string;
    agentId?: string;
    refetchInterval?: number | false;
}) => {
    const mastraClient = useMastraClient();

    return useQuery({
        queryKey: ['mastraThread', threadId, agentId],
        refetchInterval,
        queryFn: async (): Promise<StorageThreadType | null> => {
            if (threadId == null || agentId == null) {
                return null;
            }

            try {
                return await mastraClient
                    .getMemoryThread({ threadId, agentId })
                    .get();
            } catch (err) {
                captureException(err);
                throw err;
            }
        },
        enabled: threadId != null && agentId != null,
    });
};
